import React from "react";
import { useSelector, useDispatch } from "react-redux";
import ProductAddToCart from "../routs/productPage/ProductAddToCart";
import ProductInfo from "../productInfo/ProductInfo";
import { upsertCartItem } from "../../server/CollectSite";

const MiniCart = ({ setProductPopUp, setSelectedProd }) => {
  const dispatch = useDispatch();

  const { productsInCart, deliveryPrice, stationId } = useSelector((state) => ({
    productsInCart: state.productsInCart.productsInCart,
    deliveryPrice: state.productsInCart.deliveryPrice,
    stationId: state.user.stationId,
  }));

  const subtotal = productsInCart.reduce((total, item) => {
    return total + item.totalPrice;
  }, 0);

  const saleTotal = productsInCart.reduce((total, item) => {
    if (item.promoId) {
      return total + (item.unitPrice * item.quantity - item.totalPrice);
    } else {
      return total;
    }
  }, 0);

  const totalPrice = subtotal + (deliveryPrice ?? 0);

  const handleDelete = (element) => {
    // Use element.productId (same key ProductAddToCart uses)
    // so debounce timers are shared correctly across views.
    dispatch(
      upsertCartItem(
        element.productId,
        parseFloat(element.unitPrice).toFixed(2),
        0,
        String(stationId),
        element.product.pricing?.promotions?.length
          ? element.product.pricing.promotions[0].promoId
          : undefined,
        element.product, // ← pass product for rollback if needed
      ),
    );
  };

  let inSale;

  const isInSale = (product) => {
    return product.promoId &&
      product.quantity * product.unitPrice !== product.totalPrice
      ? true
      : false;
  };

  return (
    <div className="header-cart">
      <div className="header-cart-wrap">
        <div className="products">
          <table>
            <tbody>
              {productsInCart.length
                ? productsInCart.map((element) => {
                    inSale = isInSale(element);
                    return (
                      <tr
                        className="item-mini-cart"
                        key={element.productId}
                        onClick={() => {
                          setProductPopUp(true);
                          setSelectedProd(element.product);
                        }}
                      >
                        <td className="prod-info-and-name">
                          <div className="delete-item">
                            <button
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDelete(element);
                              }}
                              className="delete-btn"
                            >
                              <span className="delete-icon">✖</span>
                            </button>
                          </div>
                          <ProductInfo selectedProd={element.product} />

                          {element.promoId ? (
                            <p className="sale">במבצע!</p>
                          ) : null}
                          {element.warningMessage && (
                            <p className="comment-warning">
                              {element.warningMessage}
                            </p>
                          )}
                        </td>
                        <td className="price-details">
                          <p className="price">
                            {(element.unitPrice * element.quantity).toFixed(2)}{" "}
                            <span>₪</span>
                          </p>
                          {inSale ? (
                            <p className="sale">
                              {(
                                element.unitPrice * element.quantity -
                                element.totalPrice
                              ).toFixed(2)}{" "}
                              <span>- ₪</span>
                            </p>
                          ) : null}
                          <div
                            className="quantity"
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            <ProductAddToCart
                              element={element}
                              haveInfo={false}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })
                : null}
            </tbody>
          </table>
        </div>

        <div className="cart-summary">
          <div className="summary-row">
            <span>סה"כ:</span>
            <span>{subtotal.toFixed(2)} ₪</span>
          </div>
          <div className="summary-row">
            <span>חסכת</span>
            <span>{saleTotal.toFixed(2)} ₪</span>
          </div>
          <div className="summary-row">
            <span>משלוח:</span>
            <span>{deliveryPrice} ₪</span>
          </div>
          <div className="summary-row total">
            <span>סה"כ לתשלום:</span>
            <span>{totalPrice.toFixed(2)} ₪</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiniCart;
